import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Container, Title, Subtitle, Description } from './styles';
import { ButtonPrimary } from '../../shared/components';
import Header from '../../shared/components/PublicPageHeader';
import Footer from '../../shared/components/PublicPageFooter';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <>
      <Header color="#fff" />
      <Container>
        <Title>404</Title>
        <Subtitle>Desculpe, a página solicitada não foi encontrada...</Subtitle>
        <Description>
          Clique no botão abaixo para voltar a página inicial
        </Description>
        <ButtonPrimary.Normal
          label="Voltar para tela inicial"
          onClick={() => {
            navigate('/');
          }}
        />
      </Container>
      <Footer />
    </>
  );
}
